import { render, staticRenderFns } from "./audioChatView.vue?vue&type=template&id=cff6c660&scoped=true"
import script from "./audioChatView.vue?vue&type=script&lang=js"
export * from "./audioChatView.vue?vue&type=script&lang=js"
import style0 from "./audioChatView.vue?vue&type=style&index=0&id=cff6c660&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff6c660",
  null
  
)

export default component.exports